import { memo } from 'react';
import { spacing } from '../../constants/designTokens';
import { useTheme } from '../../contexts/ThemeContext';

const RangeSlider = memo(({
  min,
  max,
  step,
  value,
  onChange,
  disabled = false,
  label,
  hint,
  ...props
}) => {
  const { colors } = useTheme();
  const progressFactor = (value - min) / (max - min);

  return (
    <div style={{ width: '100%' }}>
      {label && (
        <label style={{
          display: 'block',
          fontSize: '0.875rem',
          fontWeight: 500,
          marginBottom: spacing.md,
          color: colors.foreground,
          fontFamily: 'Sohne, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        }}>
          {label}
        </label>
      )}
      <div style={{ 
        position: 'relative', 
        width: '100%',
        '--progress-track-factor': progressFactor,
        '--track-thickness': '8px',
        '--thumb-size': '16px',
      }}>
        <div style={{
          position: 'absolute',
          left: '0',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '100%',
          height: 'var(--track-thickness)',
          background: 'hsla(240, 1%, 44%, 0.4)',
          borderRadius: '9999px',
          pointerEvents: 'none',
        }} />
        
        <div style={{
          position: 'absolute',
          left: '0',
          top: '50%',
          transform: 'translateY(-50%)',
          width: `calc(100% * ${progressFactor})`,
          height: 'var(--track-thickness)',
          background: colors.foreground,
          borderRadius: '9999px',
          pointerEvents: 'none',
          zIndex: 5,
        }} />
        
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          disabled={disabled}
          onChange={onChange}
          style={{
            position: 'relative',
            width: '100%',
            height: 'var(--thumb-size)',
            cursor: disabled ? 'not-allowed' : 'pointer',
            appearance: 'none',
            WebkitAppearance: 'none',
            background: 'transparent',
            outline: 'none',
            opacity: disabled ? 0.6 : 1,
            zIndex: 10,
          }}
          {...props}
        />
        
        <style>{`
          input[type="range"]::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: var(--thumb-size);
            height: var(--thumb-size);
            border-radius: 50%;
            background: ${colors.foreground};
            cursor: pointer;
            transition: all 0.2s cubic-bezier(0.2, 1, 0.2, 1);
          }
          
          input[type="range"]::-webkit-slider-thumb:hover {
            transform: scale(1.3);
          }
          
          input[type="range"]:active::-webkit-slider-thumb {
            box-shadow: 0 0 0 4px hsla(0, 0%, 9%, 0.4);
          }
          
          input[type="range"]:focus-visible::-webkit-slider-thumb {
            box-shadow: 0 0 0 4px ${colors.outline};
          }
          
          input[type="range"]::-moz-range-thumb {
            width: var(--thumb-size);
            height: var(--thumb-size);
            border: none;
            border-radius: 50%;
            background: ${colors.foreground};
            cursor: pointer;
            transition: all 0.2s cubic-bezier(0.2, 1, 0.2, 1);
          }
          
          input[type="range"]::-moz-range-thumb:hover {
            transform: scale(1.3);
          }
          
          input[type="range"]:active::-moz-range-thumb {
            box-shadow: 0 0 0 4px hsla(0, 0%, 9%, 0.4);
          }
          
          input[type="range"]:focus-visible::-moz-range-thumb {
            box-shadow: 0 0 0 4px ${colors.outline};
          }
        `}</style>
      </div>
    </div>
  );
});

export default RangeSlider;